import { atomWithReset } from 'jotai/utils';

export const AppTicketSearchState = atomWithReset('');
